import * as React from "react";
import styled, { css } from "styled-components";
import Menu from "components/bootstrap/Menu";
import { NAV_ITEM_HEIGHT, NAV_ITEM_LINE_HEIGHT } from "theme/constants";
import NavItemStateIndicator, {
  hoverIndicatorStyles,
  activeIndicatorStyles
} from "components/common/NavItemStateIndicator";
const StyledMenuDropdown = styled(Menu.Dropdown)`
  z-index: 1032 !important;
`;
const DropdownTrigger = styled.button(
  ({ theme, $active }) => css`
    background: transparent;
    border: 0;
    padding: 0 15px;
    min-height: ${NAV_ITEM_HEIGHT};
    display: inline-flex;
    line-height: ${NAV_ITEM_LINE_HEIGHT};
    align-items: center;
    gap: ${theme.spacings.xs};

    &:hover,
    &:focus-visible {
      ${hoverIndicatorStyles(theme)}
      color: ${theme.colors.variant.darker.default};
      background-color: transparent;
    }

    ${$active ? activeIndicatorStyles(theme) : ""}
  `
);
const NavItem = styled.li`
  display: inline-flex;
  align-items: center;
  min-height: ${NAV_ITEM_HEIGHT};
  padding: 0;

  @media (width <= 991px) {
    width: 100%;
  }
`;
const NavDropdown = ({
  inactiveTitle = void 0,
  Badge = void 0,
  title = void 0,
  noCaret = false,
  children = void 0,
  hoverTitle = void 0
}) => {
  const isActive = inactiveTitle ? inactiveTitle !== title : void 0;
  return /* @__PURE__ */ React.createElement(Menu, null, /* @__PURE__ */ React.createElement(NavItem, null, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(DropdownTrigger, { $active: isActive, title: hoverTitle }, /* @__PURE__ */ React.createElement(NavItemStateIndicator, null, Badge ? /* @__PURE__ */ React.createElement(Badge, { text: title }) : title), " ", noCaret ? null : /* @__PURE__ */ React.createElement("span", { className: "caret" })))), /* @__PURE__ */ React.createElement(StyledMenuDropdown, null, children));
};
export default NavDropdown;
